// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__2p4vD","cycle":"Nav_cycle__1TRAf"};